import React, { Component } from 'react';

import { Container, Offcanvas, Row, Col,  Form, Tabs, Tab } from 'react-bootstrap';

import CommonInput from '../components/CommonInput';
import CommonSelect from '../components/CommonSelect';
import CommonFile from '../components/CommonFile';
import CustomDatePicker from "../components/CommonDatePicker";
import CommonButton from '../components/CommonButton';

import CommonAlert from '../components/CommonAlert';
import CommonLoadingBar from '../components/CommonLoadingBar';

import * as Actions from '../actions/ActionCenter';

import * as fn from '../../library/function';
import * as helper from '../../library/helper';
import * as util from '../../library/utilitys';

import SimpleBar from 'simplebar-react';

import InlineDemandDataManpowerEstablishmentsEducationLevel from '../inline/InlineDemandDataManpowerEstablishmentsEducationLevel';
import InlineDemandDataManpowerEstablishmentsSkillsSet from '../inline/InlineDemandDataManpowerEstablishmentsSkillsSet';
class InputDemandDataManpowerEstablishments extends Component {

        constructor(props) {
        super(props);
        this.state = {
            selectedDate: new Date(),
            activeTab: 'profile'
        };
    }

    handleDateChange = (date) => { this.setState({ selectedDate: date }); }

    handleTabSelect = (key) => { this.setState({ activeTab: key }); };       

    prepareInputs = async () => {
        const { URL, Action, Inputs, onUpdateState } = this.props;
        const isUpdateMode = Action.Mode === 'update';

        let updatedInputs = fn.setRequiredPrimaryKey(Inputs, isUpdateMode);

        onUpdateState('Inputs', updatedInputs);
    }

    componentDidUpdate = async (prevProps) => {
        if (fn.shouldPrepareInputs(prevProps.Action, this.props.Action)) {
            await this.prepareInputs();
        }
    }

    render = () => {
        let props = this.props;

        let { onInputChange, onCloseAlert, onSubmit, onDiscardSubmit, onSetEdit } = props;

        let { App, Action, Inputs, InputGroup , Operation, Masterbase, UserCookie } = props;

        let { Submit } = Operation;
        
        let { show, mode } = Action.OffCanvas;

        let isLoading = Action.Loading.submit;

        return (
                <Offcanvas 
                    show={show}
                    placement="end" 
                    style={{ '--bs-offcanvas-width': '100vw' }}
                    scroll={true}
                    backdrop={Submit ? "static" : true}
                    onHide={(e) => { 
                        this.setState({activeTab: 'profile'});
                        props.onClose(e);
                    }}
                >

                  <Offcanvas.Header closeButton className="border-bottom custom-offcanvas-header">
                        <Offcanvas.Title className="custom-offcanvas-header offcanvas-title"><i className={`${App.icon} text-white me-2`}/>{App.title}</Offcanvas.Title>
                    </Offcanvas.Header>

                     <Offcanvas.Body className="custom-offcanvas-body">
                        
                        <CommonAlert 
                            alert={Action.Alert} 
                            callback={(e) => onCloseAlert(e)}
                        />
                        
                        <SimpleBar id="inputs" className="simple-bar-input">

                            <Container fluid className="data-table-container">

                                <Tabs 
                                    defaultActiveKey="profile" 
                                    activeKey={this.state.activeTab}
                                    onSelect={(e) => this.handleTabSelect(e)}
                                    className="mb-3"
                                >

                                    <Tab eventKey="profile" title="ความต้องการกำลังคน">
                                        <Row>
                                            <Col md={1} className="mb-3">{util.formatLabel(null, Inputs.enterprise_id)}</Col>
                                            <Col md={5} className="mb-3">
                                                <CommonSelect
                                                    element="Inputs"
                                                    input={Inputs.enterprise_id}
                                                    option={{source: 'db', data: Masterbase?.enterprise}}
                                                    hr={false}
                                                    floatingLabel={false}
                                                    callback={(e, element) => onInputChange(e, element)} 
                                                    disabled={!['0', '1', '5'].includes(UserCookie.types)}
                                                />  
                                            </Col>
                                        </Row>   

                                        <Row>
                                            <Col md={1} className="mb-3">{util.formatLabel(null, Inputs.position_id)}</Col>
                                            <Col md={3} className="mb-3">
                                                <CommonSelect
                                                    element="Inputs"
                                                    input={Inputs.position_id}
                                                    option={{source: 'db', data: Masterbase?.position}}
                                                    hr={false}
                                                    floatingLabel={false}
                                                    callback={(e, element) => onInputChange(e, element)} 
                                                />  
                                            </Col>
                                        </Row>   

                                        <Row>
                                            <Col md={1} className="mb-3">{util.formatLabel(null, Inputs.target_industries_id)}</Col>
                                            <Col md={5} className="mb-3">
                                                <CommonSelect
                                                    element="Inputs"
                                                    input={Inputs.target_industries_id}
                                                    option={{source: 'db', data: Masterbase?.target_industries}}
                                                    hr={false}
                                                    floatingLabel={false}
                                                    callback={(e, element) => onInputChange(e, element)} 
                                                />  
                                            </Col>
                                        </Row>   

                                        <Row>
                                            <Col md={1} className="mb-3">{util.formatLabel(null, Inputs.years)}</Col>
                                            <Col md={2} className="mb-3">
                                                <CommonSelect
                                                    element="Inputs"
                                                    input={Inputs.years}
                                                    option={{source: 'db', data: Masterbase?.yearBEOptions}}
                                                    hr={false}
                                                    floatingLabel={false}
                                                    callback={(e, element) => onInputChange(e, element)}
                                                />
                                            </Col>
                                            <Col md={1} className="mb-3">{util.formatLabel(null, Inputs.positions)}</Col>
                                            <Col md={2} className="mb-3">
                                                <CommonInput
                                                    element="Inputs"
                                                    input={Inputs.positions}
                                                    hr={false}
                                                    floatingLabel={false}
                                                    callback={(e, element) => onInputChange(e, element)}
                                                />  
                                            </Col>
                                        </Row>  

                                        <Row>
                                            <Col md={1} className="mb-3">{util.formatLabel(null, Inputs.description)}</Col>
                                            <Col md={5} className="mb-3">
                                                <CommonInput
                                                    element="Inputs"
                                                    input={Inputs.description}
                                                    hr={false}
                                                    floatingLabel={false}
                                                    callback={(e, element) => onInputChange(e, element)}
                                                /> 
                                            </Col>
                                        </Row>
                                    </Tab>

                                    <Tab eventKey="education-level" title="ระดับการศึกษา">
                                        <Row>
                                            <Col md={{ span: 10, offset: 1 }} className="mb-3">
                                                <InlineDemandDataManpowerEstablishmentsEducationLevel
                                                    fkId="manpower_establishments_id"
                                                    fkVal={Inputs.id.value}
                                                />
                                            </Col>
                                        </Row> 
                                    </Tab>  

                                    <Tab eventKey="skills-set" title="ทักษะ Skills Set">
                                        <Row>
                                            <Col md={{ span: 10, offset: 1 }} className="mb-3">
                                                <InlineDemandDataManpowerEstablishmentsSkillsSet
                                                    fkId="manpower_establishments_id"
                                                    fkVal={Inputs.id.value}
                                                />
                                            </Col>
                                        </Row> 
                                    </Tab>

                                </Tabs>
                            
                            </Container>
                            
                        </SimpleBar>

                    </Offcanvas.Body>  


                   { this.state.activeTab === 'profile' && (
                    <div className="offcanvas-footer d-flex flex-column border-top bg-light p-3">

                        <CommonLoadingBar isLoading={isLoading} />

                        <div className="d-flex justify-content-end mt-2">
                            <CommonButton 
                                task={mode} 
                                disabled={isLoading ? true : Submit ? false : true}
                                callback={async (e) => {
                                        let currentId = Inputs.id.value;
                                        await onSubmit(e);
                                        if (Action.Mode === 'update') {
                                            onSetEdit({}, {id: currentId}); 
                                        }
                                        this.handleTabSelect('profile');
                                }} 
                            />

                            {Action.Mode === 'new' && (
                                <CommonButton 
                                    task="discard" 
                                    inlineClass="ms-1" 
                                    disabled={isLoading} 
                                    callback={(e) => onDiscardSubmit(false)} 
                                />
                            )}
                        </div>
                    </div>   
                   ) }

                </Offcanvas>   
            )
        }
}

export default InputDemandDataManpowerEstablishments;